/** Find an email anywhere in a client/API object (keys or nested). */
export function extractEmailLoose(obj) {
  if (!obj || typeof obj !== "object") return null;
  const candidates = [];
  const seen = new Set();

  const visit = (node, depth = 0) => {
    if (!node || depth > 5) return;
    if (typeof node === "string") {
      const s = node.trim();
      if (s.includes("@")) candidates.push(s);
      return;
    }
    if (typeof node !== "object") return;
    if (seen.has(node)) return;
    seen.add(node);

    if (Array.isArray(node)) {
      node.forEach((item) => visit(item, depth + 1));
      return;
    }

    Object.entries(node).forEach(([k, v]) => {
      if (v == null) return;
      if (typeof v === "string") {
        const s = v.trim();
        if (s.includes("@")) candidates.push(s);
        if (String(k).toLowerCase().includes("email") && s) candidates.push(s);
      } else if (typeof v === "object") {
        visit(v, depth + 1);
      }
    });
  };

  visit(obj, 0);
  const best =
    candidates.find((s) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(s)) || candidates[0];
  return best || null;
}
